import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { insert, selectValues, update, validarCNPJ, validarCPF } from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import MaskedInput from '../../Template/Input/MaskedInput';

const ModalFormEditFornecedor = ( props ) => {

  const [addFavModal, setAddFavModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [identificador, setIdentificador] = useState('');
  const [prevIdentificador, setPrevIdentificador] = useState('');
  /*
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [numeroConta, setNumeroConta] = useState('');
  const [pix, setPix] = useState('');
  const [tipoPix, setTipoPix] = useState({});
  const [tipoServico, setTipoServico] = useState({});
  const [municipio, setMunicipio] = useState(null);
  const [selMunicipios, setSelMunicipios] = useState(null);
  const [cep, setCep] = useState('');
  const [endLogr, setEndLogr] = useState('');
  const [endNum, setEndNum] = useState(0);
  const [endCompl, setEndCompl] = useState('');
  const [selectTipoPix, setSelectTipoPix] = useState([]);
  const [selectTipoServico, setSelectTipoServico] = useState([]);
  */


  const handleClickOpenAddFavModal = () => setAddFavModal(true);
  const handleClickCloseAddFavModal = () => setAddFavModal(false);

  const verificaIdentificador = async (isPf) => {
    var exists = false;

    if (isPf) {
      const pf = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_cpf: identificador,
        }
      })}`);

      if (pf.data[0] && identificador !== prevIdentificador) {
        console.log(identificador, prevIdentificador);
        exists = true
      };
    }

    else {
      const pj = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: {
          pj_cnpj: identificador,
        }
      })}`);

      if (pj.data[0] && identificador !== prevIdentificador) {
        console.log(identificador, prevIdentificador);
        exists = true
      };
    }

    return exists;
  }

  const handleSubmit = async () => {
    setIsLoading(true);

    let createdId = null;
    let createdRegisterTab = null;

    const existFav = await verificaIdentificador(props.isPf);
    if (existFav) {
      setIsLoading(false);
      if(props.isPf) return alert('Pessoa Física já existe');
      if(!props.isPf) return alert('Pessoa Jurídica já existe');
    }

    if (props.isPf) {
      const pfBody = {
          action: 'update',
          table: 'pf',
          data: {
          pf_id: props.contrForn_parteId,
          pf_nomeExibicao: nome,
          pf_emailProf: email,
          pf_cpf: identificador,
          /*
          pf_contaBanco: banco,
          pf_contaAgencia: agencia,
          pf_contaNum: numeroConta,
          pf_chavePix: pix,
          mun_id: municipio.value,
          pf_cep: cep,
          pixTp_id: tipoPix.value,
          */
          pf_fornecedor: 1,
        }
      }

      const cpfValido = await validarCPF(identificador);
      if (!cpfValido) {
        setIsLoading(false);
        return alert('CPF inválido');
      }

      const pfCreated = await oikosApi.post('/', pfBody)
      createdId = pfCreated.data[0].pf_id
      createdRegisterTab = 'pf';
      if (props.setSelPfsFornecedor) props.setSelPfsFornecedor((prev) => { return [ ...prev, {label: pfCreated.data[0].pf_nomeExibicao, value: pfCreated.data[0].pf_id}] })

    } else {
      const pjBody = {
        action: 'update',
        table: 'pj',
        data: {
          pj_id: props.contrForn_parteId,
          pj_razaosocial: nome,
          pj_emailPrin: email,
          pj_cnpj: identificador,
          /*
          pj_contaBanco: banco,
          pj_contaAgencia: agencia,
          pj_contaNum: numeroConta,
          pj_chavePix: pix,
          pj_cep: cep,
          mun_id: municipio.value,
          pixTp_id: tipoPix.value,
          */
          pj_fornecedor: 1,
        }
      }

      const cnpjValido = await validarCNPJ(identificador);
      if (!cnpjValido) {
        setIsLoading(false);
        return alert('CNPJ inválido');
      }

      const pjCreated = await oikosApi.post('/', pjBody)
      createdId = pjCreated.data[0].pj_id
      createdRegisterTab = 'pj';

      if (props.setSelPjsFornecedor) props.setSelPjsFornecedor((prev) => { return [ ...prev, {label: pjCreated.data[0].pj_razaosocial, value: pjCreated.data[0].pj_id}] })

    }

    if (props.setContrFornData) {
      console.log('setContrFornData', { ...props.contrFornData, contrForn_parteId: createdId, contrForn_parteTab: createdRegisterTab });
      props.setContrFornData({ ...props.contrFornData, contrForn_parteId: createdId, contrForn_parteTab: createdRegisterTab });
    }
    if (props.getFornecedores) {
      console.log('getFornecedores');
      props.getFornecedores(props.isPf);
    }

    /*
    */
   if (props.fetchSelPfs) {
     console.log('fetchSelPfs');
     props.fetchSelPfs();
   }
   if (props.handleClickCloseAddFavModal) {
     console.log('handleClickCloseAddFavModal');
     props.handleClickCloseAddFavModal();
   }


    setIsLoading(false);
  }

  const preloading = async () => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: props.isPf ? 'pf' : 'pj',
      data: {
        [props.isPf ? 'pf_id' : 'pj_id']: props.contrForn_parteId
      }
    })}`);
    console.log(res.data[0])
    setNome(res.data[0][props.isPf ? 'pf_nomeExibicao' : 'pj_razaosocial'] || '');
    setEmail(res.data[0][props.isPf ? 'pf_emailProf' : 'pj_emailPrin'] || '');
    setIdentificador(String(res.data[0][props.isPf ? 'pf_cpf' : 'pj_cnpj']).replace(/\D/g, '') || '');
    setPrevIdentificador(String(res.data[0][props.isPf ? 'pf_cpf' : 'pj_cnpj']).replace(/\D/g, '') || '');
    /*
    */
  }

  useEffect(() => {
    preloading()
  },[])

  return (
    <>
      <Btn
        size="sm"
        color="link"
        className="ml-2 px-0"
        onClick={async (e)=>{
          e.preventDefault();
          await preloading();
          handleClickOpenAddFavModal();
          //console.log(getCNPJInfo('08022237000185'))
        }}
      >
        Editar {(props.isPf) ?  'PF' : 'PJ' }
      </Btn>
      {(props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Editar
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Nome
              </Label>
              <Input
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <Label>
                E-mail
              </Label>
              <Input
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Label>
                CPF (apenas números)
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value.replace(/\D/g, ''))}
              />
              {/*
              <Label>
                Código do banco
              </Label>
              <Input
                type='number'
                value={banco}
                onChange={e => {
                  if (e.target.value.length > 3) {
                    return;
                  }
                  setBanco(e.target.value)
                }}
              />
              <Label>
                Agência
              </Label>
              <Input
                value={agencia}
                onChange={e => setAgencia(e.target.value)}
              />
              <Label>
                Número da conta
              </Label>
              <Input
                value={numeroConta}
                onChange={e => setNumeroConta(e.target.value)}
              />
              <Label>
                PIX
              </Label>
              <Input
                value={pix}
                onChange={e => setPix(e.target.value)}
              />
              <Label>
                Tipo PIX
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoPix}
                value={tipoPix}
                onChange={(e) => {
                  setTipoPix(e)
                }}
              />
              <Label>
                Municipio
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selMunicipios}
                value={municipio}
                onChange={(e) => {
                  if (e) {
                    return setMunicipio(e)
                  }
                  return setMunicipio(null);
                }}
              />
              <Label>
                CEP
              </Label>
              <MaskedInput
                unmask
                inputRef={el => {const inputVlrGlobal = el}}
                mask="00000-000"
                placeholder="00000-000"
                lazy={false}
                inputMode="numeric"
                value={String(cep)}
                onAccept={value => { setCep(value) }}
              />
              <Label>
                Tipo de serviço prestado
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoServico}
                value={tipoServico}
                onChange={(e) => {
                  setTipoServico(e)
                }}
              />
              */}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async (e) => {
                  //insOrUp( 'projStake', addStakeProjData)
                  console.log('inseriu');
                  await handleSubmit()
                  handleClickCloseAddFavModal();
                }
                }
              >
                Editar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
      {(!props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Editar
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Nome Fantasia
              </Label>
              <Input
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <Label>
                E-mail
              </Label>
              <Input
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Label>
                CNPJ (apenas números)
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
              {/*
              <Label>
                Código do banco
              </Label>
              <Input
                type='number'
                value={banco}
                onChange={e => {
                  if (e.target.value.length > 3) {
                    return;
                  }
                  setBanco(e.target.value)
                }}
              />
              <Label>
                Agência
              </Label>
              <Input
                value={agencia}
                onChange={e => setAgencia(e.target.value)}
              />
              <Label>
                Número da conta
              </Label>
              <Input
                value={numeroConta}
                onChange={e => setNumeroConta(e.target.value)}
              />
              <Label>
                PIX
              </Label>
              <Input
                value={pix}
                onChange={e => setPix(e.target.value)}
              />
              <Label>
                Tipo PIX
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoPix}
                value={tipoPix}
                onChange={(e) => {
                  setTipoPix(e)
                }}
              />
              <Label>
                Municipio
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selMunicipios}
                value={municipio}
                onChange={(e) => {
                  if (e) {
                    return setMunicipio(e)
                  }
                  return setMunicipio(null);
                }}
              />
              <Label>
                CEP
              </Label>
              <MaskedInput
                unmask
                inputRef={el => {const inputVlrGlobal = el}}
                mask="00000-000"
                placeholder="00000-000"
                lazy={false}
                inputMode="numeric"
                value={String(cep)}
                onAccept={value => { setCep(value) }}
              />
              <Label>
                Tipo de serviço prestado
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoServico}
                value={tipoServico}
                onChange={(e) => {
                  setTipoServico(e)
                }}
              />
              <Label>
                Endereço Logradouro
              </Label>
              <Input
                type='text'
                value={endLogr}
                onChange={e => setEndLogr(e.target.value)}
              />
              <Label>
                Endereço Número
              </Label>
              <Input
                type='number'
                value={endNum}
                onChange={e => setEndNum(e.target.value)}
              />
              <Label>
                Endereço Complemento
              </Label>
              <Input
                type='text'
                value={endCompl}
                onChange={e => setEndCompl(e.target.value)}
              />
              */}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async () => {
                  //insOrUp( 'projStake', addStakeProjData)
                  console.log('inseriu');
                  await handleSubmit()
                  handleClickCloseAddFavModal();
                }
                }
              >
                Editar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
    </>
  )
}

export default ModalFormEditFornecedor;
